import { Prescription } from '@/models';
import { GenericService } from '../generic.service';

export class PrescriptionService extends GenericService<Prescription> {
  constructor(patientId: string, journeyId: string, encounterId: string) {
    super();
    this.endpoint = `/menicon/v1/patients/${patientId}/journeys/${journeyId}/encounters/${encounterId}/prescriptions`;
  }
}
